/**
 * Generates a random Happy ID in the format `XXX-XXX`.
 * Each `X` is a digit between 0 and 9.
 *
 * Uses a monotonic counter + timestamp-seeded randomness to guarantee
 * uniqueness even when called multiple times in the same millisecond.
 *
 * @returns {string} The generated Happy ID.
 */
let _happyIdCounter = 0;
let _lastHappyIdTimestamp = 0;

export const generateHappyId = () => {
    const now = Date.now();
    if (now === _lastHappyIdTimestamp) {
        _happyIdCounter++;
    } else {
        _lastHappyIdTimestamp = now;
        _happyIdCounter = 0;
    }
    // Mix timestamp, counter, and randomness for unique 6-digit codes
    const seed = (now % 100000) + _happyIdCounter;
    const part1 = ((seed * 7 + Math.floor(Math.random() * 900 + 100)) % 900) + 100;
    const part2 = ((seed * 13 + Math.floor(Math.random() * 900 + 100)) % 900) + 100;
    return part1 + "-" + part2;
};